document.addEventListener('submit', e => {
  const form = e.target;
  if (form && form.matches('form.hdt-product-form')) {
    e.preventDefault();
    e.stopImmediatePropagation();
    console.log('BFG – Captured top-level submit before component handled it');

    const variantInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');
    const variantId = variantInput?.value;
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
      credentials: 'same-origin',
    })
      .then(r => r.json())
      .then(data => {
        console.log('BFG – Added to cart:', data);

        document.dispatchEvent(new CustomEvent('cart:refresh'));

        // Find and "click" the existing cart button to open the drawer
          // Small delay before opening the drawer to let cart state update
            setTimeout(() => {
              const cartButton = document.querySelector('[aria-controls="CartDrawer"], #hdt-cart-count-box, .hdt-cart-count-box');
              if (cartButton) {
                cartButton.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
                console.log('BFG – triggered cart drawer button click (after delay)');
              } else {
                console.warn('BFG – cart drawer button not found, falling back to manual drawer fetch');
                fetch('/?sections=cart-drawer', { credentials: 'same-origin' })
                  .then(r => r.json())
                  .then(sections => {
                    const parser = new DOMParser();
                    const html = parser.parseFromString(sections['cart-drawer'], 'text/html');
                    const newDrawer = html.querySelector('#CartDrawer');
                    const oldDrawer = document.querySelector('#CartDrawer');
                    if (oldDrawer && newDrawer) {
                      oldDrawer.replaceWith(newDrawer);
                      document.documentElement.classList.add('cart-drawer-open');
                    }
                  });
              }
            }, 200); // adjust 300–500ms as needed

        //
      })
      .catch(err => console.error('BFG – Add to cart error:', err));
  }
}, true); //  ← capture = true